import { AnalyticsService } from './../../services/analytics.service';
import { AfterViewInit, Component, HostListener, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

import { verifyLanguage } from '../../shared/constants/app-enums';
import { ViewportScroller } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent implements AfterViewInit {
  notificationUrl = environment.sseUrl;
  isProduction = environment.production;
  isLoaded: boolean = false;
  notificationFadeOutTime = environment.notificationTimeout
  lang!: string;
  viewportScroller: ViewportScroller = inject(ViewportScroller);
  private reachedThresholds: Record<number, boolean> = {
    25: false,
    50: false,
    75: false,
    100: false,
  };

  constructor(
    private router: Router,
    private actiateRoute: ActivatedRoute,
    private translate: TranslateService,
    private analyticsService: AnalyticsService
  ) {
    this.translate.setDefaultLang('en');
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((navEnd: NavigationEnd) => {
      // console.log('NavigationEnd', navEnd);
      let lang = navEnd.urlAfterRedirects.split('/')[1];
      // console.log('NavigationEnd filtered lang level-1 =', lang);
      lang = lang.split('#')[0];
      // console.log('NavigationEnd filtered lang level-2 =', lang);
      lang = lang.split('?')[0];
      // console.log('NavigationEnd filtered lang level-3 =', lang);

      if (lang && verifyLanguage(lang)) {
        this.lang = lang;
      } else {
        this.lang = "en"
      }
      // console.log('current language is =',this.lang)
      this.translate.use(this.lang);
    });

    this.actiateRoute.fragment.subscribe((fragment: string | null) => {
      if (fragment) {
        setTimeout(() => this.viewportScroller.scrollToAnchor(fragment as string), 1500); // Adjust delay as needed (for mobile fragment)
      }
    });
  }

  // Listen to window scroll
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.body.scrollHeight;
    const scrollPercent = ((scrollTop + windowHeight) / fullHeight) * 100;

    [25, 50, 75, 100].forEach((threshold) => {
      if (scrollPercent >= threshold && !this.reachedThresholds[threshold]) {
        this.analyticsService.vwoData('pageScrolled', { depth: `${threshold}%` });
        this.reachedThresholds[threshold] = true;
      }
    });
  }

  ngAfterViewInit(): void {
    this.isLoaded = true;
  }
}
